<div class="calendar">
    <div class="calendar-navs" >
        <div class="month-nav">
            <span class="month-name">{{ currentDate.format('MMMM') + ' ' + currentDate.format('YYYY') }}</span>
            <div class="next-prev-outer">
                <a (click)="prevMonth()" class="next-prev-btn">
                    <span> <i class="fas fa-angle-left" aria-hidden="true"></i></span>
                </a>
                <a (click)="nextMonth()" class="next-prev-btn">
                    <span><i class="fas fa-angle-right" aria-hidden="true"></i></span>
                </a>
            </div>
        </div>
    </div>
    <div class="month-grid">
        <div class="day-names">
            <div *ngFor="let name of dayNames" class="day-name p9">
                {{ name }}
            </div>
        </div>
        <div class="weeks">
            <div *ngFor="let week of weeks" class="week">
                <ng-container *ngFor="let day of week">
                    <div class="week-date disabled" style="opacity: 0.5;" *ngIf="!isSelectedMonth(day.mDate)">
                        <span class="date-text">{{ day.mDate.date() }}</span>
                    </div>
                    <div class="week-date enabled"  *ngIf="isSelectedMonth(day.mDate)" (click)="selectDate(day)"
                        [ngClass]="{ today: day.today, selected: day.selected }">
                        <span class="date-text">{{ day.mDate.date() }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>